import React, { Component } from "react";

import { getUserId, getUser } from "../helper/user_helper";
import Loader from "../components/loader";
import UserImage from "../components/user_image";
import SignUp from "./sign_up";
import Logo from "../design/img/yaystack-logo.png";
import LocalizedStrings from "react-localization";
import en from "../localization/localization-en.json";
import UserProfile from "../components/profile/user_profile";
let strings = new LocalizedStrings({ en });
class Invite extends Component {
  state = { username: null, signedIn: false };

  constructor(props) {
    super(props);
    this.state = {
      username: props.match.params.id,
      loaded: false,
      user: null
    };
  }

  componentDidMount() {
    // Check if user is already login
    const self = this;
    this.userCall = getUser();
    this.userCall.promise.then(answer => {
      if (answer.signedIn === true) {
        self.setState({ signedIn: true });
      }
    });
    this.getUserData();
  }

  componentWillUnmount() {
    if (this.userCall) {
      this.userCall.cancel();
    }
    if (this.getUserCall) {
      this.getUserCall.cancel();
    }
  }

  componentDidUpdate() {
    if (this.props.match.params.id !== this.state.username) {
      this.setState({
        loaded: false,
        username: this.props.match.params.id
      });
      this.getUserData();
    }
  }

  render() {
    if (!this.state.loaded) {
      return <Loader loaded={this.state.loaded} />;
    }
    if (this.state.signedIn) {
      return (
        <UserProfile
          username={this.state.username}
          user={this.state.user}
          me={false}
          loaded={this.state.loaded}
          handleAddFriend={this.handleAddFriend}
          handleRemoveFriend={this.handleRemoveFriend}
          errors={this.state.errors}
        />
      );
    }
    return (
      <div className="profilePage center page_top_nav">
        <label className="name pb-2">{strings.invite_join}</label>
        <div className="image-profile center">
          <UserImage user={this.state.user} />
        </div>
        <label className="name">
          {this.state.user.first_name} {this.state.user.last_name}
        </label>
        <label className="username">@{this.state.user.username}</label>
        <label
          className="username mt-2"
          style={{ color: "black", textTransform: "lowercase" }}
        >
          {strings.invite_on}
        </label>
        <div className="yaystack_return_nav_bar">
          <img src={Logo} alt="Yaystack Logo" />
        </div>
        <SignUp username={this.state.username} history={this.props.history} />
      </div>
    );
  }

  getUserData() {
    const self = this;
    this.getUserCall = getUserId(this.props.match.params.id);
    this.getUserCall.promise.then(answer => {
      if (answer.user === null) {
        self.props.history.push("/profile/");
        return;
      }
      self.setState({
        user: answer.user,
        loaded: true,
        errors: answer.errors
      });
    });
  }

  handleAddFriend = (errors, username, friendship_type) => {
    if (errors !== "") {
      this.setState({ errors });
    } else {
      var user = this.state.user;
      user.friend = true;
      user.friendship_type = friendship_type;
      user.total_followers += 1;
      this.setState({ user });
    }
  };

  handleRemoveFriend = errors => {
    if (errors !== "") {
      this.setState({ errors });
    } else {
      var user = this.state.user;
      user.friend = false;
      user.total_followers -= 1;
      this.setState({ user });
    }
  };

  handlerGoToPage = page => {
    this.props.history.push(page);
  };
}

export default Invite;



// WEBPACK FOOTER //
// ./src/pages/invite.jsx